<template>
  <div>
    <navigation> </navigation>
    <b-container id="app">
      <router-view />
    </b-container>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
export default {
  name: "App",
  components: {
    Navigation,
  },
};
</script>

<style>

body {
  overflow-x: hidden;
}

footer {
  position: relative;
  bottom: 0;
  width: 100vw;
  height: 50px;
  font-size: 12px;
}
</style>
